import { Box } from '@mui/material'
import React from 'react'
import './style/section2.css'
const Section3 = () => {
    return (

        <Box className="mt-14 flex justify-center flex-wrap " >
            <Box className=" m-5 order-2 md:order-1">
                <span className='color text-sm font-semibold uppercase'>Necklaces</span>
                <h2 className='font-semibold text-3xl my-5'>Exciting and innovative</h2>
                <p className='text-start text-sm leading-loose text-gray-600 font-medium'>Inspired by the rebellious spirit of America and the intrigue of unwavering authenticity,<br />
                    R13 launched in Fall 2009. At the forefront of design, R13 cuts avant-garde silhouettes <br />
                    such as the skinny legging and harem pant from Italian and Turkish denim produced in <br />
                    give the jeans their superior shape and an authentic...</p>
                <p className='text-start text-sm leading-loose text-gray-600 font-medium mt-5'>Inspired by the rebellious spirit of America and the intrigue of unwavering authenticity,<br />
                    R13 launched in Fall 2009. At the forefront of design, R13 cuts avant-garde silhouettes <br />
                    such as the skinny legging and harem pant from Italian and Turkish denim produced in <br />
                    Castelfranco, Italy. Pure indigo casting, quality stretch and machine hand mending<br />
                    give the jeans their superior shape ...</p>
            
            </Box>
            <Box className='image-box m-5 order-1 md:order-2'>
                <img src="https://images.pexels.com/photos/9637586/pexels-photo-9637586.jpeg?auto=compress&cs=tinysrgb&w=600" alt="" />
            </Box>
        </Box>

    )
}

export default Section3
